export { default, iconNames, sizes } from './Icon';
export type { IconName, IconSize, IconProps } from './Icon';
